/* Overrides EN (texte uniquement) pour les fiches sites. Fusionnés avec SITE_CONTENT quand lang === "en". */
export const SITE_CONTENT_EN = {
  "saint-ferreol": {
    tagline: "Carte blanche to Michel Batlle",
    hero: {
      subtitle: "80 years of creation",
      body: [
        "Michel Batlle is 80 years old. He lives in Saint-Ferréol. Forty years ago, he was already paying tribute to Riquet with a sculpture in his likeness, now standing on the Saint-Ferréol basin.",
        "A sculptor, painter and thinker, he has worked for six decades at the edges of plastic language: shamanic figures, paper cosmogonies, philosophers of harsh history. His work inhabits interior spaces and great landscapes alike with a striking presence.",
        "His works have been shown in prestigious institutions — the Château de Laréole (Haute-Garonne departmental council), the Salinger Foundation, the Abbey of Valmagne, the Soulages Museum in Rodez, the Prehistory Park of Tarascon-sur-Ariège — and in many cities in France and abroad.",
      ],
    },
    projet: {
      title: "EXPLOSITION at the Saint-Ferréol Basin",
      lead: "Les Arteurs give Michel Batlle carte blanche for the Saint-Ferréol basin — Europe's first great dam, Riquet's hydraulic masterpiece, UNESCO-listed.",
      stats: [
        { n: "30", u: "monumental sculptures", d: "3 to 5 metres tall" },
        { n: "29", u: "invited artists", d: "chosen by Michel Batlle" },
        { n: "40", u: "years", d: "after his first tribute to Riquet" },
      ],
      quote: "« 30 sculptures of 3 to 5 metres will stand on the Saint-Ferréol basin. A monumental tribute to the man and his work, 40 years on. »",
    },
    invited: {
      title: "The 29 invited artists",
      body: "Michel Batlle personally chooses the 29 artists who will accompany him. Their works will hang from the trees around the Saint-Ferréol basin, responding to the same theme.",
      note: "The artists will be announced progressively by Michel Batlle. This page is updated as confirmations come in.",
    },
    closing: {
      title: "Same place, same theme. A monumental tribute.",
      body: "Forty years ago, Michel Batlle sculpted the tribute to Riquet on the edge of this basin. Today he returns with 30 monumental works and 29 invited artists. It is the right project.",
      cta: "Discover the EXPLOSITION dossier",
    },
  },
  "castelnau": {
    tagline: "Home of the Arteurs · Inaugural chapter",
    hero: {
      heroLabel: "§ The place",
      title: "The birthplace",
      subtitle: "40 Grande Rue · Headquarters of the collective",
      body: [
        "Castelnau d'Estrétefonds is the cradle of Le Fil du Midi. It is here, on the Grande Rue, that Les Arteurs have been meeting for years to imagine, organise and bring the local art scene to life — and now, this great 750 km trail.",
        "The collective has organised many exhibitions here — including the Octobre Rose edition in partnership with the town hall — and regularly welcomes artists, patrons and audiences. The town is the project's first institutional partner.",
        "In 2026, Castelnau becomes the trail's inaugural chapter: the experimentation site where the Thread's DNA is prepared before it unfolds from the Atlantic to the Mediterranean.",
      ],
    },
    projet: {
      title: "Chapter 01 · The Thread's workshop",
      lead: "Castelnau d'Estrétefonds opens the Thread. Workshops, residencies, preparatory openings: this is where the 6 sites are invented together before deploying along the canal. Outside the UNESCO-listed zone, exhibitions can last as long as we wish.",
      stats: [
        { n: "01", u: "inaugural chapter", d: "the project's anchor point" },
        { n: "30", u: "artists", d: "invited by Les Arteurs" },
        { n: "12", u: "months of exhibition", d: "Sept 2026 → Aug 2027" },
      ],
      quote: "« Before the Thread reaches the Mediterranean, it begins in a village hall, a workshop, a shared conversation. »",
    },
    worksLabel: "§ The place · Views",
    invited: {
      title: "Michel Batlle invites",
      body: "Michel Batlle, the Thread's artistic director, personally invites 6 renowned artists who will form the core of the Castelnau chapter. The rest of the programme (30 artists in total) is co-curated with Les Arteurs and will be announced as confirmations come in.",
      note: "Are you a town, a school, an association? Join this chapter, the heart of FILM.",
    },
    closing: {
      title: "The Thread starts here.",
      body: "Following Castelnau d'Estrétefonds means following the genesis of the project. Every local event prefigures the great trail — workshops, openings, encounters with the artists.",
      cta: "Join Les Arteurs in Castelnau d'Estrétefonds",
    },
  },
  "toulouse": {
    tagline: "The pink city receives the Thread",
    hero: {
      heroLabel: "§ The invited curator",
      subtitle: "Painter · Burkina Faso",
      body: [
        "Toulouse, Riquet's city, the pink city where the Canal du Midi begins at the Port de l'Embouchure, gives carte blanche to Olga Yaméogo — a Burkinabè painter whose work inhabits female figures, African memories and colour.",
        "The Toulouse chapter will deploy 29 artists invited by Olga along the canal's banks, from the Pont-Neuf to the Ponts-Jumeaux — where the Canal latéral à la Garonne and the Canal du Midi meet. Toulouse is the geographic and symbolic knot of the trail.",
        "The programme highlights the links between West Africa and the French South-West: diasporas, textile writings, shared memories. A dialogue between the banks of one same Thread.",
      ],
    },
    projet: {
      title: "Chapter 02 · The knot of the Thread",
      lead: "The Canal du Midi's point of origin, Toulouse is the knot where all waters meet — those of the Garonne, the canal, and memories.",
      stats: [
        { n: "29", u: "invited artists", d: "curated by Olga Yaméogo" },
        { n: "05", u: "stops", d: "along the urban canal" },
        { n: "1667", u: "worksite", d: "start of the Canal du Midi" },
      ],
      quote: "« Riquet dreamed the canal here, in Toulouse. It is here that we answer him, four centuries later. »",
    },
    worksLabel: "§ Works · Olga Yaméogo's universe & the pink city",
    invited: {
      title: "The 29 invited artists",
      body: "Olga Yaméogo composes the Toulouse programme: 29 artists from around the world, in dialogue with the canal's memories and the South-West's diasporas.",
      note: "The artists will be announced progressively by Olga Yaméogo. This page is updated as confirmations come in.",
    },
    closing: {
      title: "The Toulouse knot.",
      body: "Toulouse is where everything plays out: the canal's origin, Riquet's city, a crossroads of worlds. The Thread is tied here before stretching to the sea.",
      cta: "Discover Olga Yaméogo",
    },
  },
  "castelnaudary": {
    tagline: "The watershed",
    hero: {
      heroLabel: "§ The place",
      title: "The Grand Bassin",
      subtitle: "7 hectares · 1666-1671",
      body: [
        "The Grand Bassin of Castelnaudary is the largest artificial body of water on the Canal du Midi: seven hectares, dug by Riquet's workers to serve as a harbour of refuge for 17th-century barges.",
        "Nearby, the Naurouze threshold — the watershed line between the Atlantic and the Mediterranean — marks the canal's highest point (189 m). Every drop that falls here chooses its ocean.",
        "In 2026, Castelnaudary becomes the chapter of choice, of threshold, of bifurcation. The programme will honour artists who work on the question of passage, of the line, of departure — and the quadruple Saint-Roch lock, unique of its kind.",
      ],
    },
    projet: {
      title: "Chapter 04 · The water that chooses",
      lead: "On the Grand Bassin, the Thread's artists will question the dividing line — that invisible border which decides the destiny of waters, and of artworks.",
      stats: [
        { n: "07", u: "hectares", d: "artificial body of water" },
        { n: "189", u: "m altitude", d: "Naurouze threshold" },
        { n: "1671", u: "completion", d: "under Riquet's direction" },
      ],
      quote: "« Here, the water no longer flows. It decides. »",
    },
    worksLabel: "§ The place · Views",
    invited: {
      title: "Programme in the making",
      body: "The Castelnaudary chapter is looking for its curator and its artists. Les Arteurs invite creators to respond to the theme of the watershed — sculpture, installation, land art, performance.",
      note: "Foundations, patrons and institutions: this chapter awaits its sponsor. A rare opportunity to support a major UNESCO site.",
    },
    closing: {
      title: "The chapter of the threshold.",
      body: "On the canal's largest basin, art will question what it means to choose one's direction. A site to sponsor — its history is already written.",
      cta: "Become a patron of Castelnaudary",
    },
  },
  "malpas": {
    tagline: "Photography beneath the mountain",
    hero: {
      heroLabel: "§ The invited curator",
      subtitle: "Photographer · France",
      body: [
        "Arno Brignon is a French photographer who works over the long term on landscapes, memory and people. His series — published in the press and shown at documentary photography festivals — inhabit the margins, the thresholds, the territories we cross without seeing them.",
        "The Malpas tunnel, bored in 1679-1680 beneath the Ensérune hill, is the world's first navigation tunnel. A 17th-century act of daring: Riquet had 165 metres of rock dug out to avoid a long detour. Above, the Ensérune oppidum watches over the Montady lagoon and its medieval radiating drains.",
        "Here Arno Brignon composes a photographic programme that takes the tunnel as a metaphor: crossing what seems impossible, lighting what remains in shadow, circulating images as the canal circulates water.",
      ],
    },
    projet: {
      title: "Chapter 05 · The passage",
      lead: "165 metres bored beneath the mountain. Le Malpas is the chapter of the impossible gesture — and of its image.",
      stats: [
        { n: "165", u: "m of tunnel", d: "beneath the Ensérune hill" },
        { n: "1679", u: "year of the works", d: "world's first navigable tunnel" },
        { n: "29", u: "invited photographers", d: "curated by Arno Brignon" },
      ],
      quote: "« Pierce the mountain to let the water through. Pierce the image to let the gaze through. »",
    },
    worksLabel: "§ Works · The tunnel & Arno Brignon's universe",
    invited: {
      title: "The 29 invited photographers",
      body: "Arno Brignon gathers 29 photographers around the tunnel: documentary, visual artists, young talents, great names. The images will be shown on the banks, around the portal, and in the villages of Ensérune and Colombiers.",
      note: "The photographers will be announced as confirmations come in. A residency is planned on the site in spring 2026.",
    },
    closing: {
      title: "Crossing the impossible.",
      body: "Le Malpas is the chapter of the daring gesture. To pierce, to cross, to light. Arno Brignon and 29 photographers answer it four centuries later.",
      cta: "Discover Arno Brignon",
    },
  },
  "loupian": {
    tagline: "Opening to the world · general curatorship of Canal'Art 2026",
    hero: {
      heroLabel: "§ General Curator",
      subtitle: "Chief heritage curator · Villa Loupian",
      body: [
        "Bertrand Ducourau is a chief heritage curator and director of the Loupian archaeological site museum, home to the Gallo-Roman villa and its exceptional 4th-century mosaics. Appointed to Loupian in 2025, he carries a vision of conservation in dialogue with contemporary creation — heritage as a living worksite, open to the artists of our time.",
        "There is no coincidence. What brought him south, to Toulouse in 1994, was precisely the documentary work required for the Canal du Midi's UNESCO World Heritage listing — obtained two years later, in 1996. More than thirty years on, he is general curator of the first edition of FILM, for the 30th anniversary of that very inscription. A rare loop — a biography meeting History.",
        "For Canal'Art 2026, he thus takes on a double mission: general curator of the trail — coordinator of the 6 stops — and curator of the Loupian stop, where he composes the Thread's final programme. A strong editorial choice: entrusting the man who worked for the canal's listing with bringing 30 years of UNESCO inscription into dialogue with today's art.",
        "Loupian, at the canal's Mediterranean end, becomes the chapter of the after. Bertrand Ducourau questions what art leaves behind, and what it opens ahead — on a site where history is measured in centuries, oysters in generations, and the Thread, in horizons.",
      ],
    },
    projet: {
      title: "Chapter 06 · The open sea",
      lead: "End of the canal, beginning of the sea. Loupian is the chapter of the after — of what remains, of what opens, of what overflows. Curated by Bertrand Ducourau, chief heritage curator.",
      stats: [
        { n: "260", u: "km", d: "from the Atlantic" },
        { n: "IVᵉ", u: "century", d: "Gallo-Roman villa · mosaics" },
        { n: "30", u: "invited artists", d: "by Bertrand Ducourau" },
      ],
      quote: "« The canal does not stop. It dissolves. »",
    },
    worksLabel: "§ Canal'Art 2026 simulations · Views of Loupian",
    invited: {
      title: "The 30 invited artists",
      body: "Bertrand Ducourau, general curator of Canal'Art 2026 and chief curator of the Loupian site museum, composes the Mediterranean programme. A selection in dialogue with the Gallo-Roman mosaics, oyster farming, and the horizon of the open sea.",
      note: "The full list of artists will be announced progressively by the general curator as confirmations come in.",
    },
    closing: {
      title: "Where the Thread gives itself to the open sea.",
      body: "Loupian concludes the trail under Bertrand Ducourau's curatorship. It will be the place of celebration, of the great final gathering — and of the promise of a Thread that will continue well beyond 2026.",
      cta: "Discover Bertrand Ducourau",
    },
  },
};

export const SITE_POETRY_EN = {
  "saint-ferreol": { title: "The heart of the Thread", quote: "Reservoir, source of the canal. Here beats the heart of the Fil du Midi." },
  "toulouse": { title: "The knot of the Thread", quote: "The pink city, the Garonne, the Pont-Neuf — where the engineer dreamed the canal." },
  "castelnau": { title: "The Thread's workshop", quote: "Home of Les Arteurs. The Thread coils here before radiating outward." },
  "castelnaudary": { title: "The watershed", quote: "The Grand Bassin, dividing line between the Atlantic and the Mediterranean. Here, the water chooses its ocean." },
  "malpas": { title: "The passage", quote: "A tunnel bored beneath the mountain — a 17th-century act of daring. The Thread crosses what nothing was meant to cross." },
  "loupian": { title: "Opening to the world", quote: "Lagoon, horizon, light. The canal does not stop — it dissolves into the world." },
};

export const SITE_CURATORS_EN = {
  "toulouse": {
    medium: "Painting",
    role: "Artist-curator · invites 29 artists",
    intro: "A Burkinabè painter, Olga Yaméogo composes a body of work inhabited by female figures, African memories and colour. She gathers 29 artists around the pink city.",
  },
  "malpas": {
    medium: "Photography",
    role: "Featured photographer · invites 29 artists",
    intro: "A French documentary photographer, Arno Brignon works over the long term on landscapes, memory and people. He composes the photographic programme of the Malpas tunnel and invites 29 artists.",
  },
};

export function mergeSiteContent(base, ov) {
  if (!ov) return base;
  return {
    ...base,
    ...ov,
    hero: { ...base.hero, ...(ov.hero || {}) },
    projet: { ...base.projet, ...(ov.projet || {}) },
    invited: { ...base.invited, ...(ov.invited || {}) },
    closing: { ...base.closing, ...(ov.closing || {}) },
  };
}
